import {initPlatform} from "@mytour/platform";
import {App} from "app/App";
import {createRoot} from "react-dom/client";

initPlatform();
const rootEl = document.getElementById("root");
if (rootEl) {
  createRoot(rootEl).render(<App />);
}
